import { IonGrid, IonRow, IonContent } from "@ionic/react"
import React from "react"
import Ae2Header from "../../components/AE2/Ae2Header"
import AE2CustomerForm from "../../components/forms/AE2CustomerForm"
import './Customer.css'
import AlphaInsightsHeader from "../../components/AE2/AlphaInsightsHeader"

const Customer: React.FC= () => {
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';
    return (
    <IonContent className={ newUI? 'bg-main':'ae2-customer-content'}>
    { newUI ? <AlphaInsightsHeader/> : <Ae2Header/> }

    <div className="ae2-customer">
        <div className="form-container">
            <IonGrid className="ae2-grid" >
                <IonRow className="ion-justify-content-center">
                    <AE2CustomerForm />
                </IonRow>
            </IonGrid>
        </div>
    </div>

    </IonContent>)
}

export default Customer